const groups = [
  {
    title: "快速导航",
    links: [
      { label: "地址汇总", href: "#address" },
      { label: "互换方法", href: "#switch" },
      { label: "可用检测", href: "#check" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "联系站长", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-accent-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-lg text-foreground-950">
                <i className="ri-eye-fill" />
              </span>
              <span className="text-lg font-bold text-background-50">吃瓜导航指南站</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-300">
              专注整理吃瓜网址多个地址的互换参考与可用检测方法，把备用地址存好、把切换顺序理清，追更更省心。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-facebook-circle-line", "ri-twitter-x-line", "ri-wechat-line"].map((ic) => (
                <a
                  key={ic}
                  href="#home"
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-900 text-accent-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          {groups.map((g) => (
            <div key={g.title} className="lg:col-span-2">
              <h3 className="text-sm font-semibold text-background-50">{g.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-accent-300 transition-colors hover:text-accent-100">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold text-background-50">获取提醒</h3>
            <p className="mt-4 text-sm text-accent-300">入口状态若有更新，会在这里集中说明。</p>
            <div className="mt-4 flex items-center gap-2 text-sm text-accent-300">
              <i className="ri-refresh-line" /> 地址清单定期同步
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-accent-900 pt-6 text-xs text-accent-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜导航指南站 · 本指南仅供访问参考</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-eye-fill" /> 记得把备用地址随手存好哦
          </p>
        </div>
      </div>
    </footer>
  );
}